export default __webpack_public_path__ + "static/media/nichart.25f433ba.png";